if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
'use strict';
(function(){
    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */
    flatpickr("[name=birthday]" , {dateFormat: "yy-m-d"});
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    const headerBox = document.getElementById('header') || [];

    function scrollDown(){
        let top = $(document).scrollTop();
        if (top > 20) {
            headerBox.classList.add('scroll-element');
        } else {
            headerBox.classList.remove('scroll-element');
        }
    }

    // filter rooms by tags
    const selectRoomType = [...document.getElementsByClassName('js-select-type-room')] || [];
    const roomWithTag = [...document.getElementsByClassName('room')] || [];
    const selectAllRooms = document.getElementById('view-all');

    //this function accepts two parameters, the first one checks if the rooms have the same class as the option value and the second one adds an event to each room if true
    const showAndhideRooms = (valueAllRooms, checkPerRoom) => {
        checkPerRoom.classList.remove('active-room');
        checkPerRoom.style.display = 'none';

        if(valueAllRooms){
            checkPerRoom.style.display = 'block';
            setTimeout(function () {
                checkPerRoom.classList.add('active-room');
            }, 100);
        }
    }

    //this function accepts two parameters, the first one checks if the rooms have the same class as the option value and the second one adds an event to each room
    const checkEachRoomTag = (roomsTags, valueFilter) => {
        roomsTags.forEach(tagPerRoom => {
            //this checks all the rooms and validate which rooms have the same value of the current 'all view' btn
            let checkTagPerRoom = tagPerRoom.classList.contains(valueFilter); //
            showAndhideRooms(checkTagPerRoom, tagPerRoom);
        });
    }

    const resetAllDropDown = (allSelectsOption, currentSelectOption) => {

        allSelectsOption.forEach(currentSelect => {
            if( currentSelect !== currentSelectOption ){
                currentSelect.value = "";
            }
        });

    }

    //filter rooms by 'view all' btn
    if(selectAllRooms !== null){
        selectAllRooms.addEventListener('click', function () {
            let valueAllRoomsBtn = this.getAttribute('value');

            resetAllDropDown(selectRoomType);

            checkEachRoomTag(roomWithTag, valueAllRoomsBtn);
        });
    }

    //filter rooms by dropdown option
    selectRoomType.forEach(roomTypeSelect => {
        roomTypeSelect.addEventListener('change', function () {
            let selectChange = this;
            let valueSelectOption = this.options[this.selectedIndex].value;

            resetAllDropDown(selectRoomType, selectChange);

            checkEachRoomTag(roomWithTag, valueSelectOption);
        });
    });

    $('.sym-slides').slick();

    $(document).ready(function () {

        scrollDown();

        //Acts when scroll down page.
        $(window).scroll(function (event) {
            scrollDown();
        });
        
        $("#post-466772 a.btn").html(function(buscayreemplaza, reemplaza) {
            return reemplaza.replace('Book Appointment', 'PURCHASE');
        });

        $("#tag-wellness-circuit.tag-wellness-circuit").html(function(buscayreemplaza, reemplaza) {
            return reemplaza.replace('<h2 class="top-menu-tags wellness-circuit">wellness-circuit</h2>', '<h2 class="top-menu-tags wellness-circuit">Wellness Circuit</h2>');
        });

        $("#tag-body-therapy.tag-body-therapy").html(function(buscayreemplaza, reemplaza) {
            return reemplaza.replace('<h2 class="top-menu-tags body-therapy">body-therapy</h2>', '<h2 class="top-menu-tags body-therapy">Body Therapy</h2>');
        });

        
       


        // Filtered shortcode
        var btn_filteredContent = $("a.expand-filtered-content");
        btn_filteredContent.click(function (e) {
            e.preventDefault();
            if($(this).hasClass('change-icon')) {
                $("a.expand-filtered-content").removeClass('change-icon');
                $("div.filtered-content").slideUp(500);
            } else {
                $("a.expand-filtered-content").removeClass('change-icon');
                $(this).addClass('change-icon');
                $("div.filtered-content").slideUp(500);
                var expand = $(this).data("expand");
                setTimeout(function () {
                    $(".filtered-content[data-expand-container="+expand+"]").slideToggle();
                }, 500)

            }
        });

        var btn_togglePost = $("a.toggle-post");
        btn_togglePost.click(function(e){
            e.preventDefault();
            //HIDE ALL POST & REMOVED ACTIVE CLASS
            var post_hide_filtered = $(this).data("expand-filtered");
            $(".filtered-content[data-expand-container="+post_hide_filtered+"] .hidden-post").hide();
            $(".filtered-content[data-expand-container="+post_hide_filtered+"] a.toggle-post").removeClass("active");

            //SHOW THE CORRECT ONE
            var post_show = $(this).data("post");
            $(this).addClass("active");
            $(".hidden-post[data-show="+post_show+"]").show();
        });


        //accordion module

        const tabAccordionElement = [...document.getElementsByClassName('js-title-toggle')] || [];
        const contentAccordionElement = [...document.getElementsByClassName('js-info-toggle')] || [];

        tabAccordionElement.forEach(function (elementTab) {
            elementTab.addEventListener('click', function () {
                const clickedElement = this;
                clickedElement.classList.toggle('change-icon');
                tabAccordionElement.forEach(function(elementClass) {
                    if( elementClass !== clickedElement )
                        elementClass.classList.remove('change-icon');
                });
                contentAccordionElement.forEach(function (elementContent) {
                    let dataElementTab = elementTab.dataset.expand;
                    let dataElementContent = elementContent.dataset.expand;

                    elementContent.classList.add('info-toggle');

                    if(elementTab.classList.contains('change-icon')){
                        if(dataElementTab === dataElementContent){
                            elementContent.classList.remove('info-toggle');
                        }
                    }else{
                        if(dataElementTab === dataElementContent){
                            elementContent.classList.add('info-toggle');
                        }
                    }
                })
            });
        })
    });

}());


//vanilla js scroll TO animation
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
